function About() {
  return (
    <>
      <h1 className='text-6xl mb-4'>GitHub Search Engine</h1>
      <p className='mb-4 text-2xl font-light'>
      Search GitHub by name or company and the app connects to the GitHub API to display the data. 
      Created with React, Tailwind CSS and Daisy UI.
      </p>
    </>
  )
}

export default About
